module.exports = __webpack_public_path__ + "static/img/DefaultLogo.f98de1b4.png";